<!-- Content Header (Page header) -->
<div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6"> 
          <h3 >{{ titulo }} <i class="{{ icono }}"></i> </h3>
        </div><!-- /.col -->
       
        
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            
            
              <li class="breadcrumb-item pr-2">
                  <button class="btn btn-danger" (click)="volver()">
                    <i class="fas fa-window-close fa-lg"></i>
                  </button>
              </li>

          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
</div>
<!-- /.content-header -->
